<template>
  <div>
    <div id="header">
      <a href="https://wolves.live/"><img src="../assets/Sams_wolf.png"></a>
      <div id="menuBar">
        <ul id="k-list">

          <li><a href="https://wolves.live">HOME</a></li>
          <li><a href="https://wolves.live/map">MAP</a></li>
          <li><a href="https://wolves.live/about/">ABOUT</a></li>
        </ul>
      </div>
    </div>

  <!--<LocationBanner/>
    <Map
      :wolves="wolves"
      :posts="posts"
      :playerLocation="playerLocation"
    />
   

    <div class="form">
      <UploadForm/>
    </div>
  -->
  <NoPlayBanner/>

  <Gallery
      :posts="posts"
    />
  </div>
</template>

<script>
import Map from "@/components/Map";
import Gallery from "@/components/Gallery";
import LocationBanner from "@/components/LocationBanner";
import UploadForm from "@/components/UploadForm";
import NoPlayBanner from "@/components/NoPlayBanner";

export default {
  name: "Tracker",
  components: {
    UploadForm,
    LocationBanner,
    Map,
    Gallery,
    NoPlayBanner
  },
  data() {
    return {
      posts: [],
      locationEnabled: true
    };
  },
  computed: {
    wolves() {
      return this.$store.state.wolves.locations;
    },
    playerLocation() {
      return this.$store.state.geolocation;
    }
  },
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.$store.dispatch("wolves/refresh");

      let { data: posts } = await this.$http.get("/api/media");
      this.posts = posts.data;
    }
  },
  timers: {
    refresh: { time: 5000, autostart: true, repeat: true }
  }
};
</script>

<style scoped>
#header {
  background-color: lightgrey;
  text-align: left;
  padding: 0px;
  margin: 0px;
}

#header img {
  padding-left: 45px;
  padding-top: 25px;
  vertical-align: middle;
  display: block;
  width: auto;
  max-height: 80px;
}

a {
  color: #2c3e50;
}
a:hover {
  color: #dd3333 !important;
  text-decoration: none;
}

a:visited {
  color: #2c3e50;
}

a:active {
  color: #dd3333 !important;
}

#menuBar {
  vertical-align: center;
  text-align: right !important;
  max-width: 1200px;
  margin: auto;
  padding-bottom: 1px;
  padding-right: 20px;
}

ul #k-list {
  padding-bottom: 10px;
  line-height: 20px;
  font-family: Cabin;
}

#k-list li {
  list-style-type: none;
  display: inline;
  font-weight: 400;
  font-size: 12px !important;
  padding-right: 15px;
}

.form {
  width: 50%;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Tracker.vue